/**
 * @generated SignedSource<<bc58f748ca02ef1c881002f1244c2211>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type userField_servicedeskCustomerServiceCustomDetails$data = {
  readonly id: string;
  readonly name: string;
  readonly platformValue?: {
    readonly __typename: "CustomerServiceUserDetailValue";
    readonly accountId: string | null | undefined;
    readonly avatarUrl: string | null | undefined;
    readonly name: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"readViewUserField_servicedeskCustomerServiceCustomDetails">;
  readonly " $fragmentType": "userField_servicedeskCustomerServiceCustomDetails";
};
export type userField_servicedeskCustomerServiceCustomDetails$key = {
  readonly " $data"?: userField_servicedeskCustomerServiceCustomDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"userField_servicedeskCustomerServiceCustomDetails">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includePlatformValue"
    }
  ],
  "kind": "Fragment",
  "name": "userField_servicedeskCustomerServiceCustomDetails",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    (v0/*: any*/),
    {
      "condition": "includePlatformValue",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "platformValue",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                },
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "avatarUrl"
                }
              ],
              "type": "CustomerServiceUserDetailValue"
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includePlatformValue",
          "variableName": "includePlatformValue"
        }
      ],
      "kind": "FragmentSpread",
      "name": "readViewUserField_servicedeskCustomerServiceCustomDetails"
    }
  ],
  "type": "CustomerServiceCustomDetailValue"
};
})();

(node as any).hash = "3e38f846626245850708fcf82fe45c9f";

export default node;
